import React, { useState } from "react";
import {
  Grid, Paper, Typography, Box, Stack, TextField, Button, Chip, IconButton, Divider
} from "@mui/material";

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

function Card({ title, subtitle, children }) {
  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px solid var(--border)", bgcolor: "var(--branco)" }}>
      <Typography sx={{ fontWeight: 900, color: "var(--cise-text)" }}>{title}</Typography>
      {subtitle && <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 0.3 }}>{subtitle}</Typography>}
      <Box sx={{ mt: 2 }}>{children}</Box>
    </Paper>
  );
}

export default function PipelineTab() {
  const [stages, setStages] = useState(["Novo", "Qualificação", "Em conversa", "Agendamento", "Matrícula"]);
  const [lostReasons, setLostReasons] = useState(["Preço", "Horário", "Sem interesse", "Concorrente"]);
  const [tags, setTags] = useState(["Kids", "Teens", "Adulto", "Urgente", "Online", "Presencial"]);

  const [newStage, setNewStage] = useState("");
  const [newReason, setNewReason] = useState("");
  const [newTag, setNewTag] = useState("");

  const add = (value, setter, list, setList) => {
    const v = value.trim();
    if (!v) return;
    if (list.some((x) => x.toLowerCase() === v.toLowerCase())) return;
    setList([...list, v]);
    setter("");
  };

  const removeAt = (idx, list, setList) => {
    setList(list.filter((_, i) => i !== idx));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={7}>
        <Card title="Etapas do funil" subtitle="Ordem do SDR (arrasto vai entrar depois)">
          <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} sx={{ mb: 2 }}>
            <TextField
              value={newStage}
              onChange={(e) => setNewStage(e.target.value)}
              size="small"
              fullWidth
              placeholder="Adicionar etapa (ex.: Reengajamento)"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 999, background: "var(--bg)" } }}
            />
            <Button
              variant="contained"
              startIcon={<AddOutlinedIcon />}
              sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
              onClick={() => add(newStage, setNewStage, stages, setStages)}
            >
              Adicionar
            </Button>
          </Stack>

          <Paper elevation={0} sx={{ border: "1px solid var(--border)", borderRadius: 2, overflow: "hidden" }}>
            {stages.map((s, idx) => (
              <Box key={s} sx={{ px: 2, py: 1.4, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Chip
                    label={`${idx + 1}`}
                    size="small"
                    sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--bg)" }}
                  />
                  <Typography sx={{ fontWeight: 900 }}>{s}</Typography>
                </Stack>

                <IconButton size="small" onClick={() => removeAt(idx, stages, setStages)} title="Remover">
                  <DeleteOutlineOutlinedIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Paper>

          <Typography sx={{ mt: 2, color: "var(--cise-text-muted)", fontSize: 13 }}>
            Depois a gente adiciona drag & drop e regras por etapa.
          </Typography>
        </Card>
      </Grid>

      <Grid item xs={12} md={5}>
        <Stack spacing={2}>
          <Card title="Motivos de perda" subtitle="Padroniza relatórios e qualidade do funil">
            <Stack direction="row" spacing={1} sx={{ mb: 1.5 }}>
              <TextField
                value={newReason}
                onChange={(e) => setNewReason(e.target.value)}
                size="small"
                fullWidth
                placeholder="Adicionar motivo"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 999, background: "var(--bg)" } }}
              />
              <IconButton
                onClick={() => add(newReason, setNewReason, lostReasons, setLostReasons)}
                sx={{ border: "1px solid var(--border)", borderRadius: 2 }}
              >
                <AddOutlinedIcon fontSize="small" />
              </IconButton>
            </Stack>

            <Stack direction="row" gap={1} flexWrap="wrap">
              {lostReasons.map((r, idx) => (
                <Chip
                  key={r}
                  label={r}
                  onDelete={() => removeAt(idx, lostReasons, setLostReasons)}
                  sx={{ fontWeight: 900 }}
                />
              ))}
            </Stack>
          </Card>

          <Card title="Tags" subtitle="Classificação rápida (Kids/Teens/Adulto, etc.)">
            <Stack direction="row" spacing={1} sx={{ mb: 1.5 }}>
              <TextField
                value={newTag}
                onChange={(e) => setNewTag(e.target.value)}
                size="small"
                fullWidth
                placeholder="Adicionar tag"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 999, background: "var(--bg)" } }}
              />
              <IconButton
                onClick={() => add(newTag, setNewTag, tags, setTags)}
                sx={{ border: "1px solid var(--border)", borderRadius: 2 }}
              >
                <AddOutlinedIcon fontSize="small" />
              </IconButton>
            </Stack>

            <Stack direction="row" gap={1} flexWrap="wrap">
              {tags.map((t, idx) => (
                <Chip
                  key={t}
                  label={t}
                  onDelete={() => removeAt(idx, tags, setTags)}
                  sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--branco)" }}
                />
              ))}
            </Stack>

            <Divider sx={{ my: 2 }} />

            <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13 }}>
              Campos customizados (idade, disponibilidade, objetivo) entram depois.
            </Typography>
          </Card>
        </Stack>
      </Grid>
    </Grid>
  );
}